import api from "./apiClient";

export const apiGet = async (url, options = {}) => {
    try {
        let params = {};
        if (options.params) {
            params = options.params;
        } else {
            params = options;
        }

        const response = await api.get(url, { params });
        return response;

    } catch (error) {
        handleError(error);
    }
};

export const apiPost = async (url, data = {}, config = {}) => {
    try {
        let finalData = data;
        if (typeof data === "string") {
            try {
                const parsed = JSON.parse(data);
                finalData = parsed;
                config.headers = {
                    ...(config.headers || {}),
                    "Content-Type": "application/json"
                };
            } catch {
            }
        }

        const response = await api.post(url, finalData, config);
        return response;

    } catch (error) {
        handleError(error);
        throw error;
    }
};

export const apiPut = async (url, data = {}) => {
    try {
        const response = await api.put(url, data);
        return response;
    } catch (error) {
        handleError(error);
    }
};

export const apiDelete = async (url) => {
    try {
        const response = await api.delete(url);
        return response;
    } catch (error) {
        handleError(error);
    }
};

function handleError(error) {
    if (error.response) {
        console.error("API Error:", error.response.data);
        if (error.response.data.code == 'AUTH_NO_Access') {
            window.location.href = "/unauthorized";
        }
    } else {
        console.error("Network error:", error);
    }

    throw error;
}
